import { ReactNode, Fragment } from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

interface SelectionActionsProps {
    numberOfSelectedItems: number
    selectedActions: ReactNode[]
}

export function SelectionActions({ numberOfSelectedItems, selectedActions }: SelectionActionsProps) {
    const theme = useTheme()
    return (
        <Collapse
            orientation="horizontal"
            in={numberOfSelectedItems > 0}
            timeout={theme.transitions.duration.shortest}
            sx={{ flexShrink: 0, '@media (prefers-reduced-motion: reduce)': { transition: 'none' } }}
        >
            <Box
                inert={numberOfSelectedItems === 0}
                sx={{ display: 'flex', alignItems: 'center', gap: 1, pl: 2, whiteSpace: 'nowrap' }}
            >
                <Typography variant="body2" component="div" aria-live="polite">
                    {numberOfSelectedItems} selected
                </Typography>
                {selectedActions.map((action, i) => (
                    <Fragment key={i}>{action}</Fragment>
                ))}
            </Box>
        </Collapse>
    )
}
